export const ACCESS_CODES = Object.freeze({
  ACCESS_DENIED: 'ACCESS_DENIED',
  DASHBOARD_ONLY: 'DASHBOARD_ONLY',
});

export const allow = () => ({
  allowed: true,
});

export const deny = ({
  code = ACCESS_CODES.ACCESS_DENIED,
  redirectTo = '/access-denied',
} = {}) => ({
  allowed: false,
  code,
  redirectTo,
});

export const getUserClubId = user => {
  const rawClubId = user?.club?.id ?? user?.club;
  const clubId = Number(rawClubId);

  return Number.isInteger(clubId) ? clubId : null;
};

export const isNhlUser = user => getUserClubId(user) === 1;

export const isNhlAdmin = user => isNhlUser(user) && user?.role === 'admin';

export const requireNhlUser = ({ user }) =>
  isNhlUser(user)
    ? allow()
    : deny();

export const requireNhlAdmin = ({ user }) =>
  isNhlAdmin(user)
    ? allow()
    : deny();

export const canAccessAdvert = ({ user, advert }) => {
  if (isNhlUser(user)) {
    return true;
  }

  const userClubId = getUserClubId(user);
  const advertClubId = Number(advert?.club_id);

  return (
    userClubId !== null &&
    advert?.club_id !== null &&
    advert?.club_id !== undefined &&
    Number.isInteger(advertClubId) &&
    userClubId === advertClubId
  );
};
